// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutUs from "./pages/AboutUs";
import Services from "./pages/Services";
import ContactUs from "./pages/ContactUs";
import Portfolio from "./pages/Portfolio"
import ProjectDetail from './pages/ProjectDetail';
import { ProjectProvider } from "./pages/ProjectContext";
import PrivacyPolicy from './pages/PrivacyPolicy'; 
import CookiePolicy from './pages/CookiePolicy'
import HepbandmeDemo from './pages/HepbandmeDemo';

function App() {
  return (
    <ProjectProvider>
    <Router>
    <div className="flex flex-col min-h-screen"> {/* NEW wrapper */}
      <Navbar />
      <main className="flex-1">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/hepbandme" element={<HepbandmeDemo />} />
        {/* <Route path="/portfolio/:id" element={<ProjectDetail projects={projects} />}/>  
         */}
      </Routes>
      </main>
      <Footer />
    </div>
    </Router>
    </ProjectProvider>
  );
}

export default App;
